"use strict";
exports.__esModule = true;
exports.toImageWithCredits = void 0;
var utils_1 = require("@lglp/utils");
var image_1 = require("../fields/image");
var rich_text_1 = require("../fields/rich-text");
var toImageWithCredits = function (prismicData, logger) {
    var prismicImageWithCredits = utils_1.unprefix('image-with-credits', prismicData);
    if (prismicImageWithCredits) {
        var image = logger.required(image_1.toImage(prismicImageWithCredits.image, logger));
        if (!image) {
            return undefined;
        }
        return utils_1.compact({
            image: image,
            credits: rich_text_1.toRichText(prismicImageWithCredits.credits, logger)
        });
    }
};
exports.toImageWithCredits = toImageWithCredits;
//# sourceMappingURL=image-with-credits.js.map